import { ModalEntityEnum } from "@/src/modals/shared/enums/modals";
import { MODAL_URL_HASH_ENTITY_TYPE, MODAL_HASH_REGEX } from "@/src/utils/modals/constants";

const isUserLoggedIn = () => window.EASY.currentUser?.logged ?? false;

const isModalAlreadyOpen = () => Boolean(window.EasyVue.modalInstance);

const parseModalFromHash = (hash: string) => {
  const match = MODAL_HASH_REGEX.exec(hash);
  if (!match) return null;

  const [, modalType, id] = match;
  return { modalType, id };
};

const normalizeModalType = (modalType: string) => {
  if (modalType === MODAL_URL_HASH_ENTITY_TYPE.TIME_ENTRY) return ModalEntityEnum.LOG_TIME;

  return modalType;
};

const getModalOptions = (modalType: string) => {
  if (modalType === ModalEntityEnum.PBI) {
    return { boardUrl: window.location.pathname };
  }
  return undefined;
};

export const openModalFromUrlHash = () => {
  if (!isUserLoggedIn() || isModalAlreadyOpen()) return;

  const modalData = parseModalFromHash(window.location.hash);
  if (!modalData) return;

  const { modalType, id } = modalData;
  const normalizedModalType = normalizeModalType(modalType);
  const options = getModalOptions(normalizedModalType);

  window.EasyVue.showModal(normalizedModalType, id, options);
};
